let lastEventId: string | undefined;

export function recordLastEventId(uuid: string | undefined) {
  if (uuid) lastEventId = uuid;
}

export function readLastEventId(): string | undefined {
  return lastEventId;
}
